import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '@ui-nuvertos/shared';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PerformanceService {
  private routeLoadTimes: Map<string, number> = new Map();
  private router = inject(Router);

  constructor() {
    this.trackRoutePerformance();
  }

  private trackRoutePerformance(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const loadTime = performance.now();
        this.routeLoadTimes.set(event.url, loadTime);
        
        // Log performance metrics in development
        if (!environment.production) {
          console.log(`Route ${event.url} loaded in ${loadTime.toFixed(2)}ms`);
        }
      });
  }

  getRouteLoadTime(url: string): number | undefined {
    return this.routeLoadTimes.get(url);
  }

  getPerformanceMetrics(): any {
    return {
      routeLoadTimes: Object.fromEntries(this.routeLoadTimes),
      totalRoutes: this.routeLoadTimes.size,
      averageLoadTime: this.calculateAverageLoadTime()
    };
  }

  private calculateAverageLoadTime(): number {
    const times = Array.from(this.routeLoadTimes.values());
    return times.length > 0 ? times.reduce((a, b) => a + b, 0) / times.length : 0;
  }
}
